/**
 * Gets the content attribute value from a meta tag
 *
 * @return {string}
 */
export const getMetaValue = (name) =>
  document.querySelector(`meta[name=${name}]`)?.content
